module.exports = __webpack_public_path__ + "static/img/2支付方式_03.78edacff.png";